<template>
  <section class="ai-explanation-section gradient-bg text-white py-100">
    <div class="container">
      <div class="row justify-content-center text-center">
        <div class="col-lg-10">
          <!-- 🧠 Заголовок -->
          <h2 class="section-title text-gradient mb-4">
            🤖 {{ t('ai_explanation.ai_explanation.title') }}
          </h2>

          <p class="section-description mb-5">
            {{ t('ai_explanation.ai_explanation.intro') }}
          </p>
        </div>
      </div>

      <!-- 🔹 Контент -->
      <div class="row justify-content-center">
        <div class="col-md-10 col-lg-8">
          <!-- Как работает -->
          <div class="info-group mb-5 text-start">
            <h5 class="fw-semibold text-uppercase mb-3 text-white">
              {{ t('ai_explanation.ai_explanation.how_it_works.title') }}
            </h5>
            <ul class="list-unstyled text-light">
              <li v-for="i in 4" :key="i" class="py-1 d-flex align-items-start">
                <span class="ti-control-forward mr-2 text-accent mt-1"></span>
                <span>{{ t(`ai_explanation.ai_explanation.how_it_works.step${i}`) }}</span>
              </li>
            </ul>
          </div>

          <!-- Модели -->
          <div class="info-group mb-5 text-start">
            <h5 class="fw-semibold text-uppercase mb-3 text-white">
              {{ t('ai_explanation.ai_explanation.models.title') }}
            </h5>
            <ul class="list-unstyled text-light small">
              <li class="py-1">
                <strong>XGBoost:</strong> {{ t('ai_explanation.ai_explanation.models.xgboost') }}
              </li>
              <li class="py-1">
                <strong>LightGBM:</strong> {{ t('ai_explanation.ai_explanation.models.lightgbm') }}
              </li>
              <li class="py-1">
                <strong>Random Forest:</strong> {{ t('ai_explanation.ai_explanation.models.randomforest') }}
              </li>
              <li class="py-1">
                <strong>Neural Network:</strong> {{ t('ai_explanation.ai_explanation.models.neural') }}
              </li>
              <li class="py-1">
                <strong>Ridge / Linear Regression:</strong> {{ t('ai_explanation.ai_explanation.models.regression') }}
              </li>
            </ul>
          </div>

          <!-- Анализ рынка -->
          <div class="info-group text-start">
            <h5 class="fw-semibold text-uppercase mb-3 text-white">
              {{ t('ai_explanation.ai_explanation.market.title') }}
            </h5>
            <p class="small text-light">
              {{ t('ai_explanation.ai_explanation.market.desc') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>

<style scoped>
.ai-explanation-section {
  background: linear-gradient(135deg, #1a1a1a 0%, #212529 100%);
  color: #fff;
  position: relative;
  padding-top: 80px;
  padding-bottom: 80px;
}

.text-gradient {
  background: linear-gradient(90deg, #00c6ff, #007bff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.text-accent {
  color: #00bfff;
}

.section-title {
  font-size: 2rem;
  font-weight: 700;
}

.section-description {
  font-size: 1.1rem;
  color: #d1d1d1;
  line-height: 1.7;
}

.info-group h5 {
  font-size: 1rem;
  letter-spacing: 0.5px;
  color: #fff;
}

.info-group ul li {
  opacity: 0.95;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .section-title {
    font-size: 1.6rem;
  }
  .section-description {
    font-size: 1rem;
  }
}
</style>
